import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { useMassActions, useNotification } from '../../../../../hooks'
import { stopPropagation } from '../../../../../utils/events'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  getListingsMassActionNotificationTitle,
  LISTING_ACTION_RESTORE,
} from '../../../../RentalPortalListing'
import { performRentalPortalArchiveRestore } from '../../RentalPortalArchive.api'
import {
  getIsRentalPortalArchiveActionRestore,
  getIsRentalPortalArchiveRestoreAllowed,
  getRentalPortalArchiveRestoreDescription,
} from '../../RentalPortalArchive.utils'

import RestoreIcon from '../../../../../icons/restore.svg'

export function useRentalPortalArchiveRowActions({
  setModal,
  onClose,
  onReload,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { getAsyncTaskId, handleAddAsyncMassActionNotification } =
    useMassActions({
      getNotificationTitle: getListingsMassActionNotificationTitle,
      onSuccessHandler: onReload,
    })

  function restoreItem(item) {
    return performRentalPortalArchiveRestore(item)
      .then(({ data }) => {
        onClose()

        const asyncTask = getAsyncTaskId(data)

        if (asyncTask) {
          handleAddAsyncMassActionNotification({
            action: LISTING_ACTION_RESTORE,
            task: asyncTask,
          })

          return null
        }

        if (data.success_ids.length === 0) {
          handleAddErrorNotification({
            textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
            title: t('RentalPortal.ArchiveRestoreErrorKey'),
            onClickTextButton: () => setItemAction(item),
          })

          return null
        }

        handleAddSuccessNotification('Notification.CommonTitleRestoredKey')

        return onReload()
      })
      .catch(() => {
        onClose()

        handleAddErrorNotification({
          textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
          title: t('RentalPortal.ArchiveRestoreErrorKey'),
          onClickTextButton: () => setItemAction(item),
        })
      })
  }

  function setItemAction(item) {
    if (!getIsRentalPortalArchiveRestoreAllowed(item)) {
      return null
    }

    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: RestoreIcon } },
          submitText: t('RentalPortal.ListingRestoreBtnKey'),
        }}
        description={getRentalPortalArchiveRestoreDescription({ item, t })}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={onClose}
        onSubmit={event => {
          stopPropagation(event)

          return restoreItem(item)
        }}
      />
    )
  }

  function handleCallItemAction(action, item) {
    return getIsRentalPortalArchiveActionRestore(action)
      ? setItemAction(item)
      : null
  }

  return { handleCallItemAction }
}
